import { render, staticRenderFns } from "./MyNavbar.vue?vue&type=template&id=f23d5546&"
import script from "./MyNavbar.vue?vue&type=script&lang=ts&"
export * from "./MyNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./MyNavbar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports